import { BaseProvider } from './base-provider';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "./globals.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./ls-helper.service";
import * as i4 from "./lookup.service";
import * as i5 from "@ngx-translate/core";
export class MultiLanguageService extends BaseProvider {
    constructor(globals, http, ls, lookupService, translate) {
        super();
        this.globals = globals;
        this.http = http;
        this.ls = ls;
        this.lookupService = lookupService;
        this.translate = translate;
        this.currentLanguage = 'es';
        this.isLoading = false;
        this.languageChangeEvent = new Subject();
        this.baseUrl = 'lookup';
    }
    setCurrentLanguage() {
        var lang = this.ls.get('SELECTED_LANGUAGE');
        this.currentLanguage = lang ? lang : 'es';
    }
    trigger() {
        this.setCurrentLanguage();
        this.retrigger = new Date().getTime();
    }
    translateLabel(label) {
        var returnLabel = label;
        if (returnLabel == null || returnLabel == 'null') {
            return '';
        }
        try {
            returnLabel = this.ml[`${this.currentLanguage}.${label}`];
            if (returnLabel == undefined) {
                returnLabel = label;
            }
        }
        catch (e) { }
        return returnLabel;
    }
    verifyVersion() {
        return new Promise((resolve, reject) => {
            if (this.isLoading)
                resolve(null);
            this.setCurrentLanguage();
            this.isLoading = true;
            this.url = this.globals.dataUrl + this.baseUrl + '/hub/MLVersion/true';
            this.http.get(this.url).subscribe((data) => {
                let config = JSON.parse(data[0])[0];
                let version = this.ls.get('MLVersion');
                if (version != config.value) {
                    this.getLatestLanguage().then(() => {
                        this.ls.set('MLVersion', config.value);
                        this.ml = this.ls.get('ML');
                        this.isLoading = false;
                        //console.log("trigger");
                        this.trigger();
                        this.lookupService.setArrayLanguage();
                        resolve(null);
                    });
                }
                else {
                    this.ml = this.ls.get('ML');
                    this.lookupService.setArrayLanguage();
                    this.isLoading = false;
                    resolve(null);
                }
            }, (err) => {
                reject(err);
            });
        });
    }
    getLatestLanguage() {
        return new Promise((resolve, reject) => {
            this.url = this.globals.dataUrl + this.baseUrl + '/hub/ML/true';
            this.http.get(this.url).subscribe((data) => {
                let config = JSON.parse(data[0])[0];
                let ml = JSON.parse(config.value);
                this.ls.set('ML', ml);
                resolve(null);
            }, (err) => {
                reject(err);
            });
        });
    }
    toggleLanguage() {
        var lang = this.ls.get('SELECTED_LANGUAGE');
        this.currentLanguage = lang == 'es' ? 'en' : 'es';
        this.translate.use(this.currentLanguage);
        this.ls.set('SELECTED_LANGUAGE', this.currentLanguage);
        this.trigger();
        this.languageChangeEvent.next(this.currentLanguage);
        this.lookupService.setArrayLanguage();
    }
}
MultiLanguageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function MultiLanguageService_Factory() { return new MultiLanguageService(i0.ɵɵinject(i1.GlobalsService), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.LsHelperService), i0.ɵɵinject(i4.LookupService), i0.ɵɵinject(i5.TranslateService)); }, token: MultiLanguageService, providedIn: "root" });
